<template>
  <div class="container">
    <div class="row">
      <div class="col col-8 offset-2 col-centered pt-5">
        <h1 class="mb-5">{{ $t("imprint.title") }}</h1>
        <div class="mb-5">
          <p>Angaben gem&auml;&szlig; &sect; 5 TMG</p>
          <p>Campuskraft</p>
          <p>Inhaber: Michael Schöffmann</p>
          <p>Gruber Stra&szlig;e 1</p>
          <p>85586 Poing</p>
        </div>
        <div v-html="$t('imprint.one')"></div>
        <div v-html="$t('imprint.two')"></div>
        <div v-html="$t('imprint.three')"></div>
      </div>
    </div>
  </div>
</template>

<script>
import CLayout from "@/layouts/LayoutAlternative.vue";
export default {
  name: "Imprint",
  created() {
    this.$emit("update:layout", CLayout);
  },
};
</script>

<style scoped>
h1 {
  margin-top: 120px;
}
</style>
